import * as React from "react";
import { forwardRef } from "react";
const SvgChevronRight = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", viewBox: "0 0 16 16", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.47 11.53a.75.75 0 0 1 0-1.06L8.94 8 6.47 5.53a.75.75 0 1 1 1.061-1.06l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 0 1-1.06 0Z" }));
const ForwardRef = forwardRef(SvgChevronRight);
export default ForwardRef;
